import { apiClient } from "@apis/apiClient";

const usageAnalyticsClient = {
  trackPageView(url: string, title: string): void {
    apiClient
      .post("/rest/usage_analytics/event", {
        hostname: window.location.hostname,
        screen: `${window.screen.width}x${window.screen.height}`,
        language: navigator.language,
        referrer: document.referrer,
        url,
        title,
      })
      .catch(() => {});
  },

  trackCustomEvent(
    name: string,
    data?: Record<string, unknown>,
  ): void {
    apiClient
      .post("/rest/usage_analytics/event", {
        hostname: window.location.hostname,
        screen: `${window.screen.width}x${window.screen.height}`,
        language: navigator.language,
        url: window.location.pathname,
        title: document.title,
        name,
        data,
      })
      .catch(() => {});
  },

  identify(data: Record<string, unknown>): void {
    apiClient
      .post("/rest/usage_analytics/identify", {
        hostname: window.location.hostname,
        data,
      })
      .catch(() => {});
  },
};

export default usageAnalyticsClient;
